
export default function ForAttorneysPage() {
  return (
    <div className="min-h-screen bg-white font-playfair">
      {/* Navigation */}
      <nav className="bg-white shadow-sm border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center py-6">
            {/* Left Navigation - Desktop */}
            <div className="hidden md:flex items-center space-x-8">
              <a href="/for-attorneys" className="text-teal-600 font-medium tracking-wide transition-colors">For Attorneys</a>
              <a href="/#services" className="text-gray-900 hover:text-teal-600 font-medium tracking-wide transition-colors">Services</a>
            </div>

            {/* Centered Logo */}
            <div className="flex items-center justify-center flex-grow md:flex-grow-0">
              <h1>
                <a href="/">
                  <img 
                    src="https://static.readdy.ai/image/a19705f045df358eda503236ce656b36/846ee1e93f81f94b53dc3e9fa39ac791.png" 
                    alt="VTC Legal - Fractional General Counsel for AI and Tech Companies" 
                    className="h-20 w-auto"
                  />
                </a>
              </h1>
            </div>
            
            {/* Right Navigation - Desktop */}
            <div className="hidden md:flex items-center space-x-8">
              <a href="/about" className="text-gray-900 hover:text-teal-600 font-medium tracking-wide transition-colors">About</a>
              <a href="/#how-it-works" className="text-gray-900 hover:text-teal-600 font-medium tracking-wide transition-colors">How It Works</a>
              <a href="/#contact" className="bg-black text-white px-8 py-3 rounded-md hover:bg-gray-800 transition-colors whitespace-nowrap cursor-pointer font-medium">Get Started</a>
            </div>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="bg-white py-20">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-5xl font-bold text-gray-900 mb-8 font-playfair">
              Strategic Partnership for Law Firms
            </h2>
            <p className="text-xl text-gray-700 mb-12 max-w-4xl mx-auto leading-relaxed font-inter">
              Extend your firm's capabilities with specialized technology law expertise. Seamless integration for project-based collaboration and client success.
            </p>
          </div>

          <div className="grid lg:grid-cols-2 gap-16 items-center">
            <div>
              <h3 className="text-3xl font-bold text-gray-900 mb-8 font-playfair">Why Partner With VTC Legal?</h3>
              <div className="space-y-8">
                <div className="flex items-start">
                  <div className="w-12 h-12 bg-teal-600 rounded-lg flex items-center justify-center mr-6 flex-shrink-0">
                    <i className="ri-cpu-line text-white text-xl"></i>
                  </div>
                  <div>
                    <h4 className="text-xl font-bold text-gray-900 mb-3 font-playfair">Deep Technology Expertise</h4>
                    <p className="text-gray-700 leading-relaxed font-inter">
                      Specialized knowledge in AI governance, SaaS compliance, and emerging technology regulations that complement your firm's general practice areas.
                    </p>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="w-12 h-12 bg-teal-600 rounded-lg flex items-center justify-center mr-6 flex-shrink-0">
                    <i className="ri-team-line text-white text-xl"></i>
                  </div>
                  <div>
                    <h4 className="text-xl font-bold text-gray-900 mb-3 font-playfair">Seamless Client Integration</h4>
                    <p className="text-gray-700 leading-relaxed font-inter">
                      Work as an extension of your team, maintaining your client relationships while providing specialized counsel on technology matters.
                    </p>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="w-12 h-12 bg-teal-600 rounded-lg flex items-center justify-center mr-6 flex-shrink-0">
                    <i className="ri-trophy-line text-white text-xl"></i>
                  </div>
                  <div>
                    <h4 className="text-xl font-bold text-gray-900 mb-3 font-playfair">Enhanced Client Value</h4>
                    <p className="text-gray-700 leading-relaxed font-inter">
                      Offer sophisticated technology legal services without the overhead of hiring full-time specialized attorneys.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-gray-50 p-10 rounded-2xl">
              <h3 className="text-2xl font-bold text-gray-900 mb-8 font-playfair text-center">Partnership Benefits</h3>
              
              <div className="space-y-6">
                <div className="flex items-center justify-between py-4 border-b border-gray-200">
                  <span className="font-semibold text-gray-900 font-inter">Revenue Sharing</span>
                  <i className="ri-check-line text-teal-600 text-xl"></i>
                </div>
                <div className="flex items-center justify-between py-4 border-b border-gray-200">
                  <span className="font-semibold text-gray-900 font-inter">Client Relationship Control</span>
                  <i className="ri-check-line text-teal-600 text-xl"></i>
                </div>
                <div className="flex items-center justify-between py-4 border-b border-gray-200">
                  <span className="font-semibold text-gray-900 font-inter">Malpractice Coverage</span>
                  <i className="ri-check-line text-teal-600 text-xl"></i>
                </div>
                <div className="flex items-center justify-between py-4 border-b border-gray-200">
                  <span className="font-semibold text-gray-900 font-inter">Flexible Engagement</span>
                  <i className="ri-check-line text-teal-600 text-xl"></i>
                </div>
                <div className="flex items-center justify-between py-4">
                  <span className="font-semibold text-gray-900 font-inter">Professional Development</span>
                  <i className="ri-check-line text-teal-600 text-xl"></i>
                </div>
              </div>

              <div className="mt-8 p-6 bg-white rounded-xl border border-gray-200">
                <div className="text-center">
                  <div className="text-lg font-bold text-gray-900 font-inter mb-2">Project-Based Collaboration</div>
                  <div className="text-sm text-gray-600 font-inter">Flexible arrangements tailored to your clients' needs</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Services Integration */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h3 className="text-4xl font-bold text-gray-900 mb-8 font-playfair">How We Integrate With Your Practice</h3>
            <p className="text-xl text-gray-700 max-w-3xl mx-auto font-inter">
              Seamless collaboration models designed to enhance your firm's capabilities and client outcomes
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-12 mb-16">
            <div className="text-center">
              <div className="w-20 h-20 bg-gray-900 rounded-2xl flex items-center justify-center mx-auto mb-8">
                <span className="text-white text-2xl font-bold font-inter">1</span>
              </div>
              <h4 className="text-xl font-bold text-gray-900 mb-4 font-playfair">Of Counsel Arrangement</h4>
              <p className="text-gray-700 leading-relaxed font-inter">
                Formal of counsel relationship for ongoing technology matters. Perfect for firms with regular tech clients needing specialized expertise.
              </p>
            </div>

            <div className="text-center">
              <div className="w-20 h-20 bg-gray-900 rounded-2xl flex items-center justify-center mx-auto mb-8">
                <span className="text-white text-2xl font-bold font-inter">2</span>
              </div>
              <h4 className="text-xl font-bold text-gray-900 mb-4 font-playfair">Project Collaboration</h4>
              <p className="text-gray-700 leading-relaxed font-inter">
                Matter-specific partnerships for complex transactions, compliance projects, or strategic initiatives requiring technology law expertise.
              </p>
            </div>

            <div className="text-center">
              <div className="w-20 h-20 bg-gray-900 rounded-2xl flex items-center justify-center mx-auto mb-8">
                <span className="text-white text-2xl font-bold font-inter">3</span>
              </div>
              <h4 className="text-xl font-bold text-gray-900 mb-4 font-playfair">Referral Partnership</h4>
              <p className="text-gray-700 leading-relaxed font-inter">
                Structured referral arrangements with revenue sharing for clients needing specialized technology legal counsel.
              </p>
            </div>
          </div>

          <div className="bg-white rounded-2xl p-12 shadow-lg border border-gray-200">
            <h3 className="text-3xl font-bold text-gray-900 mb-8 text-center font-playfair">Expertise Areas for Collaboration</h3>
            
            <div className="grid md:grid-cols-2 gap-8">
              <div>
                <h4 className="text-xl font-bold text-gray-900 mb-6 font-playfair">Technology Transactions</h4>
                <ul className="space-y-3 text-gray-700 font-inter">
                  <li className="flex items-center">
                    <i className="ri-arrow-right-s-line text-teal-600 mr-2"></i>
                    Enterprise SaaS agreements and licensing
                  </li>
                  <li className="flex items-center">
                    <i className="ri-arrow-right-s-line text-teal-600 mr-2"></i>
                    AI/ML service agreements and data use
                  </li>
                  <li className="flex items-center">
                    <i className="ri-arrow-right-s-line text-teal-600 mr-2"></i>
                    Strategic technology partnerships
                  </li>
                  <li className="flex items-center">
                    <i className="ri-arrow-right-s-line text-teal-600 mr-2"></i>
                    API agreements and integrations
                  </li>
                  <li className="flex items-center">
                    <i className="ri-arrow-right-s-line text-teal-600 mr-2"></i>
                    Cloud services and hosting agreements
                  </li>
                </ul>
              </div>

              <div>
                <h4 className="text-xl font-bold text-gray-900 mb-6 font-playfair">Regulatory & Compliance</h4>
                <ul className="space-y-3 text-gray-700 font-inter">
                  <li className="flex items-center">
                    <i className="ri-arrow-right-s-line text-teal-600 mr-2"></i>
                    AI governance and regulatory compliance
                  </li>
                  <li className="flex items-center">
                    <i className="ri-arrow-right-s-line text-teal-600 mr-2"></i>
                    Data privacy and GDPR compliance
                  </li>
                  <li className="flex items-center">
                    <i className="ri-arrow-right-s-line text-teal-600 mr-2"></i>
                    Cybersecurity and incident response
                  </li>
                  <li className="flex items-center">
                    <i className="ri-arrow-right-s-line text-teal-600 mr-2"></i>
                    Sector-specific technology regulations
                  </li>
                  <li className="flex items-center">
                    <i className="ri-arrow-right-s-line text-teal-600 mr-2"></i>
                    International technology compliance
                  </li>
                </ul>
              </div>

              <div>
                <h4 className="text-xl font-bold text-gray-900 mb-6 font-playfair">Corporate Matters</h4>
                <ul className="space-y-3 text-gray-700 font-inter">
                  <li className="flex items-center">
                    <i className="ri-arrow-right-s-line text-teal-600 mr-2"></i>
                    Technology company formations and structures
                  </li>
                  <li className="flex items-center">
                    <i className="ri-arrow-right-s-line text-teal-600 mr-2"></i>
                    Venture capital and growth equity transactions
                  </li>
                  <li className="flex items-center">
                    <i className="ri-arrow-right-s-line text-teal-600 mr-2"></i>
                    Technology M&A due diligence
                  </li>
                  <li className="flex items-center">
                    <i className="ri-arrow-right-s-line text-teal-600 mr-2"></i>
                    Equity compensation and option plans
                  </li>
                  <li className="flex items-center">
                    <i className="ri-arrow-right-s-line text-teal-600 mr-2"></i>
                    Board governance for tech companies
                  </li>
                </ul>
              </div>

              <div>
                <h4 className="text-xl font-bold text-gray-900 mb-6 font-playfair">Intellectual Property</h4>
                <ul className="space-y-3 text-gray-700 font-inter">
                  <li className="flex items-center">
                    <i className="ri-arrow-right-s-line text-teal-600 mr-2"></i>
                    Software licensing and open source compliance
                  </li>
                  <li className="flex items-center">
                    <i className="ri-arrow-right-s-line text-teal-600 mr-2"></i>
                    Trade secret protection and policies
                  </li>
                  <li className="flex items-center">
                    <i className="ri-arrow-right-s-line text-teal-600 mr-2"></i>
                    Technology transfer agreements
                  </li>
                  <li className="flex items-center">
                    <i className="ri-arrow-right-s-line text-teal-600 mr-2"></i>
                    AI model and data licensing
                  </li>
                  <li className="flex items-center">
                    <i className="ri-arrow-right-s-line text-teal-600 mr-2"></i>
                    Employee invention agreements
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Workflow Integration */}
      <section className="py-20 bg-white">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h3 className="text-4xl font-bold text-gray-900 mb-8 font-playfair">Seamless Workflow Integration</h3>
            <p className="text-xl text-gray-700 max-w-3xl mx-auto font-inter">
              Designed to complement your existing processes and client service standards
            </p>
          </div>

          <div className="grid lg:grid-cols-2 gap-16">
            <div>
              <h4 className="text-2xl font-bold text-gray-900 mb-8 font-playfair">Client Communication</h4>
              <div className="space-y-6">
                <div className="flex items-start">
                  <div className="w-8 h-8 bg-teal-600 rounded-full flex items-center justify-center mr-4 mt-1 flex-shrink-0">
                    <i className="ri-check-line text-white text-sm"></i>
                  </div>
                  <div>
                    <h5 className="font-semibold text-gray-900 mb-2 font-inter">Your Firm Leads All Client Contact</h5>
                    <p className="text-gray-700 text-sm font-inter">You maintain primary client relationships and communication channels</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="w-8 h-8 bg-teal-600 rounded-full flex items-center justify-center mr-4 mt-1 flex-shrink-0">
                    <i className="ri-check-line text-white text-sm"></i>
                  </div>
                  <div>
                    <h5 className="font-semibold text-gray-900 mb-2 font-inter">Coordinated Response Strategy</h5>
                    <p className="text-gray-700 text-sm font-inter">We develop responses together, you deliver to maintain consistency</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="w-8 h-8 bg-teal-600 rounded-full flex items-center justify-center mr-4 mt-1 flex-shrink-0">
                    <i className="ri-check-line text-white text-sm"></i>
                  </div>
                  <div>
                    <h5 className="font-semibold text-gray-900 mb-2 font-inter">Transparent Collaboration</h5>
                    <p className="text-gray-700 text-sm font-inter">Clients understand the collaborative model and specialized expertise</p>
                  </div>
                </div>
              </div>
            </div>

            <div>
              <h4 className="text-2xl font-bold text-gray-900 mb-8 font-playfair">Billing & Administration</h4>
              <div className="space-y-6">
                <div className="flex items-start">
                  <div className="w-8 h-8 bg-gray-900 rounded-full flex items-center justify-center mr-4 mt-1 flex-shrink-0">
                    <i className="ri-arrow-right-line text-white text-sm"></i>
                  </div>
                  <div>
                    <h5 className="font-semibold text-gray-900 mb-2 font-inter">Single Client Invoice</h5>
                    <p className="text-gray-700 text-sm font-inter">Streamlined billing through your firm maintains client simplicity</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="w-8 h-8 bg-gray-900 rounded-full flex items-center justify-center mr-4 mt-1 flex-shrink-0">
                    <i className="ri-arrow-right-line text-white text-sm"></i>
                  </div>
                  <div>
                    <h5 className="font-semibold text-gray-900 mb-2 font-inter">Flexible Fee Arrangements</h5>
                    <p className="text-gray-700 text-sm font-inter">Hourly, project-based, or revenue-sharing models available</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="w-8 h-8 bg-gray-900 rounded-full flex items-center justify-center mr-4 mt-1 flex-shrink-0">
                    <i className="ri-arrow-right-line text-white text-sm"></i>
                  </div>
                  <div>
                    <h5 className="font-semibold text-gray-900 mb-2 font-inter">Detailed Time Tracking</h5>
                    <p className="text-gray-700 text-sm font-inter">Comprehensive reporting for transparency and client billing</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-16 bg-gray-50 rounded-2xl p-12">
            <h4 className="text-2xl font-bold text-gray-900 mb-8 text-center font-playfair">Professional Standards & Ethics</h4>
            
            <div className="grid md:grid-cols-3 gap-8">
              <div className="text-center">
                <div className="w-16 h-16 bg-teal-600 rounded-xl flex items-center justify-center mx-auto mb-6">
                  <i className="ri-shield-check-line text-white text-2xl"></i>
                </div>
                <h5 className="font-semibold text-gray-900 mb-3 font-inter">Malpractice Coverage</h5>
                <p className="text-gray-700 text-sm font-inter">Comprehensive professional liability insurance with technology specialization coverage</p>
              </div>

              <div className="text-center">
                <div className="w-16 h-16 bg-teal-600 rounded-xl flex items-center justify-center mx-auto mb-6">
                  <i className="ri-lock-line text-white text-2xl"></i>
                </div>
                <h5 className="font-semibold text-gray-900 mb-3 font-inter">Confidentiality Protocols</h5>
                <p className="text-gray-700 text-sm font-inter">Strict client confidentiality and privilege protection across all collaboration models</p>
              </div>

              <div className="text-center">
                <div className="w-16 h-16 bg-teal-600 rounded-xl flex items-center justify-center mx-auto mb-6">
                  <i className="ri-gavel-line text-white text-2xl"></i>
                </div>
                <h5 className="font-semibold text-gray-900 mb-3 font-inter">Ethics Compliance</h5>
                <p className="text-gray-700 text-sm font-inter">Full compliance with Model Rules of Professional Conduct in all jurisdictions</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="py-20 bg-black">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h3 className="text-4xl font-bold text-white mb-8 font-playfair">
            Ready to Explore Partnership Opportunities?
          </h3>
          <p className="text-xl text-gray-300 mb-12 max-w-2xl mx-auto font-inter">
            Let's discuss how we can collaborate to better serve your technology clients and grow your practice.
          </p>
          <div className="flex flex-col sm:flex-row gap-6 justify-center">
            <a href="/#contact" className="bg-teal-600 text-white px-12 py-4 rounded-lg text-lg font-semibold hover:bg-teal-700 transition-colors whitespace-nowrap cursor-pointer inline-block font-inter">
              Schedule Discussion
            </a>
            <a href="mailto:sergio@vtclegal.com" className="border-2 border-white text-white px-12 py-4 rounded-lg text-lg font-semibold hover:bg-white hover:text-black transition-colors whitespace-nowrap cursor-pointer inline-block font-inter">
              Email Directly
            </a>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-50 text-gray-900 py-20 border-t border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <p className="text-gray-600 text-sm font-inter">
            © 2026 VTC Legal. All rights reserved.
          </p>
        </div>
      </footer>
    </div>
  );
}
